export const TOGGLE_THEME = 'THEME::TOGGLE_THEME';

export const toggleTheme = () => ({
    type: TOGGLE_THEME
});
